'use strict';

/**
 * Send event to Google Tag Manager dataLayer
 * @param {string} eventName - Event name
 * @param {Object} eventData - Event data
 */
function pushEventToDataLayer(eventName, eventData) {
    var event = eventData || {};
    event.event = eventName;

    window.dataLayer.push(event);
}

/**
 * Gets Shop the Look context from page data (if available).
 * The context is one-shot: it is cleared after being read so it only applies
 * to the single add-to-bag that follows the Shop the Look carousel click,
 * and does not leak into unrelated Quick Shop add-to-cart events.
 * @returns {Object} STL context or null
 */
function getShopTheLookContext() {
    if (window.stlContext && typeof window.stlContext === 'object') {
        var stlContext = {
            carouselPositionSelected: window.stlContext.carouselPositionSelected,
            stlItemIdSelected: window.stlContext.stlItemIdSelected,
            stlLookId: window.stlContext.stlLookId,
            stlAnchorItemId: window.stlContext.stlAnchorItemId,
            stlPdpReferral: window.stlContext.stlPdpReferral
        };
        window.stlContext = null;
        return stlContext;
    }
    return null;
}

/**
 * Sends quickShopAddToBag event when Add to Bag is clicked from Quick Shop
 * @param {Object} qsContext - Quick Shop context (qsOriginUrl, qsSheetType)
 * @param {Object} stlContext - Shop the Look context (if available)
 * @param {Object} atcData - Add to Cart product data
 */
function pushQuickShopAddToBagEvent(qsContext, stlContext, atcData) {
    var eventData = {};

    if (qsContext) {
        eventData.qsOriginUrl = qsContext.qsOriginUrl;
        eventData.qsSheetType = qsContext.qsSheetType || 'singleProduct';
    }

    if (stlContext) {
        eventData.carouselPositionSelected = stlContext.carouselPositionSelected;
        eventData.stlItemIdSelected = stlContext.stlItemIdSelected;
        eventData.stlLookId = stlContext.stlLookId;
        eventData.stlAnchorItemId = stlContext.stlAnchorItemId;
        eventData.stlPdpReferral = stlContext.stlPdpReferral;
    }

    if (atcData) {
        eventData.color = atcData.color;
        eventData.color_value = atcData.color_value;
        // Only include contentsquare_color_value when productAdd also contains it (per Timothy Field, 02.08.2026)
        if (atcData.contentsquare_color_value) {
            eventData.contentsquare_color_value = atcData.contentsquare_color_value;
        }
        eventData.quantity = atcData.quantity;
        eventData.size = atcData.size;
        eventData.collegiate = atcData.collegiate;
        eventData.dmpk = atcData.dmpk;
        eventData.style_number = atcData.style_number;
        eventData.master_upc = atcData.master_upc;
        eventData.upc = atcData.upc;
    }

    pushEventToDataLayer('quickShopAddToBag', eventData);
}

module.exports = {
    pushEventToDataLayer: pushEventToDataLayer,
    pushQuickShopAddToBagEvent: pushQuickShopAddToBagEvent,
    getShopTheLookContext: getShopTheLookContext
};
